import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { getClientPrequalifyingFields } from './details-form-client-prequalifying';
import { getClientBankingFields } from './details-form-client-banking';
import { getClientReferralFields } from './details-form-client-referral';
import { getClientPersonalFields } from './details-form-client-personal';
import { getClientSpeakOnBehalfsFields } from './details-form-client-speak-on-behalfs';
import { getClientEmploymentFields } from './details-form-client-employment';

/**
 * SECTION 2: CLIENT INFORMATION
 */
export function getClientFields(options: DetailsFormOptions): FormlyFieldConfig[] {
	return [
		{
			type: 'tabs',
			fieldGroup: [
				{
					props: {
						label: 'Pre-qualifying',
					},
					fieldGroup: getClientPrequalifyingFields(options),
				},
				{
					props: {
						label: 'Referral',
					},
					fieldGroup: getClientReferralFields(options),
				},
				{
					props: {
						label: 'Personal',
					},
					fieldGroup: getClientPersonalFields(options),
				},
				{
					props: {
						label: 'Speak on behalf',
					},
					fieldGroup: getClientSpeakOnBehalfsFields(options),
				},
				{
					props: {
						label: 'Banking',
					},
					fieldGroup: getClientBankingFields(options),
				},
				{
					props: {
						label: 'Employment',
					},
					fieldGroup: getClientEmploymentFields(options),
				},
			]
		},
	];
}